import { render, staticRenderFns } from "./AmlAddBlack.vue?vue&type=template&id=390d1dc3&"
import script from "./AmlAddBlack.vue?vue&type=script&lang=js&"
export * from "./AmlAddBlack.vue?vue&type=script&lang=js&"
import style0 from "./AmlAddBlack.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports